<form [formGroup]="form" class="one-column">
  <mat-form-field appearance="fill">
    <mat-label>Înălțime sol-streașina (A)</mat-label>
    <input matInput type="text" autocomplete="off" pattern="^[0-9]+[,.]?[0-9]*$"
           (change)="formDecimalInputChange($event, 'groundToEavesHeight')"
           [required]="true"
           formControlName="groundToEavesHeight">
    <span matSuffix>metri</span>
  </mat-form-field>
  <div class="form-warning" *ngIf="this.form?.controls?.groundToEavesHeight?.value > 100">
    {{ getNotInMetersWarningText('groundToEavesHeight') }}
    <button (click)="updateToMeters('groundToEavesHeight')">Schimbă</button>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>Număr coborâri burlan</mat-label>
    <input matInput type="number" step="1" autocomplete="off" min="0" max="10" pattern="^\d*$" formControlName="eavesDescents"
           [required]="true">
    <span matSuffix>nr.</span>
  </mat-form-field>
</form>
